import api from './apiConfig';

const BASE_URL = '/prompts';

const promptService = {

  
  getAll: async () => {
    try {
      const response = await api.get(BASE_URL);
      return response.data;
    } catch (error) {
      console.error('Error fetching prompts:', error);
      throw error;
    }
  },

  
  getComposed: async (codexType) => {
    try {
      const response = await api.get(`${BASE_URL}/composed`, { params: { codexType } });
      return response.data;
    } catch (error) {
      console.error('Error fetching composed prompt:', error);
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`${BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching prompt ${id}:`, error);
      throw error;
    }
  },

  create: async (prompt) => {
    try {
      const response = await api.post(BASE_URL, prompt);
      return response.data;
    } catch (error) {
      console.error('Error creating prompt:', error);
      throw error;
    }
  },

  update: async (id, prompt) => {
    try {
      const response = await api.put(`${BASE_URL}/${id}`, prompt);
      return response.data;
    } catch (error) {
      console.error(`Error updating prompt ${id}:`, error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      await api.delete(`${BASE_URL}/${id}`);
    } catch (error) {
      console.error(`Error deleting prompt ${id}:`, error);
      throw error;
    }
  },

  toggleStatus: async (id) => {
    try {
      const response = await api.put(`${BASE_URL}/${id}/toggle`);
      return response.data;
    } catch (error) {
      console.error(`Error toggling prompt ${id} status:`, error);
      throw error;
    }
  },

  // Fragments
  getAllFragments: async () => {
    try {
      const response = await api.get(`${BASE_URL}/fragments`);
      return response.data;
    } catch (error) {
      console.error('Error fetching fragments:', error);
      throw error;
    }
  },

  getFragmentById: async (id) => {
    try {
      const response = await api.get(`${BASE_URL}/fragments/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching fragment ${id}:`, error);
      throw error;
    }
  },

  createFragment: async (fragment) => {
    try {
      const response = await api.post(`${BASE_URL}/fragments`, fragment);
      return response.data;
    } catch (error) {
      console.error('Error creating fragment:', error);
      throw error;
    }
  },

  updateFragment: async (id, fragment) => {
    try {
      const response = await api.put(`${BASE_URL}/fragments/${id}`, fragment);
      return response.data;
    } catch (error) {
      console.error(`Error updating fragment ${id}:`, error);
      throw error;
    }
  },

  deleteFragment: async (id) => {
    try {
      await api.delete(`${BASE_URL}/fragments/${id}`);
    } catch (error) {
      console.error(`Error deleting fragment ${id}:`, error);
      throw error;
    }
  },

  // Prompt-Fragment associations
  addFragmentToPrompt: async (promptId, fragmentId) => {
    try {
      const response = await api.post(`${BASE_URL}/${promptId}/fragments/${fragmentId}`);
      return response.data;
    } catch (error) {
      console.error(`Error adding fragment ${fragmentId} to prompt ${promptId}:`, error);
      throw error;
    }
  },

  removeFragmentFromPrompt: async (promptId, fragmentId) => {
    try {
      await api.delete(`${BASE_URL}/${promptId}/fragments/${fragmentId}`);
    } catch (error) {
      console.error(`Error removing fragment ${fragmentId} from prompt ${promptId}:`, error);
      throw error;
    }
  },

  reorderFragments: async (promptId, fragmentIds) => {
    try {
      const response = await api.put(`${BASE_URL}/${promptId}/fragments/reorder`, { fragmentIds });
      return response.data;
    } catch (error) {
      console.error(`Error reordering fragments for prompt ${promptId}:`, error);
      throw error;
    }
  },

  getAllFragmentTypes: async () => {
    try {
      const response = await api.get(`${BASE_URL}/fragment-types`);
      return response.data;
    } catch (error) {
      console.error('Error fetching fragment types:', error);
      throw error;
    }
  },

};

export default promptService; 